import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";

/**
 * @name BaseLose
 * @class BaseLose
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class BaseLose extends ConnectedHTMLElement {
  static observedAttributes = ["player"];
  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    this.render();
  }

  render() {
    const player = this.getAttribute("player");
    if (
      this.state.currentGame === undefined ||
      this.state.currentGame.winner === undefined ||
      this.state.currentGame.winner === player
    ) {
      this.innerHTML = "";
      return;
    }
    this.innerHTML = `
          <img
          alt="You lose"
          height="400"
          id="loss-overlay"
          loading="lazy"
          src="/assets/img/loss.png"
          width="557"
          class="absolute bottom-0 left-0 w-full h-auto z-10"
        />
        `;
  }

  connectedCallback() {
    this.render();
  }
}
